module.exports = __webpack_public_path__ + "img/p7.babe3d5.png";